export default function AdminLoadingScreen({
  message = 'Cargando...',
  variant = 'content',
}) {
  return (
    <div
      className={`admin-loading admin-loading--${variant}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="admin-loading__content">
        <div className="admin-loading__spinner" aria-hidden />
        {message ? <p className="admin-loading__message">{message}</p> : null}
      </div>
    </div>
  );
}
